import Box from "@amzn/meridian/esm/components/box";
import Button from "@amzn/meridian/esm/components/button";
import Column from "@amzn/meridian/esm/components/column";
import Icon from "@amzn/meridian/esm/components/icon";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import cogTokens from "@amzn/meridian-tokens/base/icon/cog";
import stopTokens from "@amzn/meridian-tokens/base/icon/stop";
import vectorIcon from "../../images/vector.svg";
import vectorIconActive from "../../images/vector_active.svg";
import { THEME_COLOR, VIEWS } from "./constants";

/**
 * Footer - Bottom navigation bar with End, Summaries, and Settings buttons.
 */
const Footer = ({ showEndButton, onEndClick, onSummariesClick, onSettingsClick, activeView }) => (
  <Box width="362px" height="75px" backgroundColor="#F7F6F8">
    <Row widths="fill" width="362px" alignmentHorizontal="center" alignmentVertical="center" height="100%" spacing="none">
      {showEndButton && (
        <Button onClick={onEndClick} type="link" size="large">
          <Column alignmentHorizontal="center" spacing="none">
            <div style={{ transform: "scale(0.80)" }}><Icon tokens={stopTokens} color="error" /></div>
            <Text type="b200" color="error">End</Text>
          </Column>
        </Button>
      )}
      <Button onClick={onSummariesClick} type="link" size="large">
        <Column alignmentHorizontal="center" spacing="none">
          <div style={{ transform: "scale(0.80)" }}><img src={activeView === VIEWS.SUMMARIES || activeView === VIEWS.SUMMARY_DETAIL ? vectorIconActive : vectorIcon} alt="Summaries" style={{ display: "block" }} /></div>
          <Theme tokens={{ textColorPrimary: THEME_COLOR.TEAL_GREEN }}>
            <Text type="b200" color={activeView === VIEWS.SUMMARIES || activeView === VIEWS.SUMMARY_DETAIL ? "primary" : "secondary"}>Summaries</Text>
          </Theme>
        </Column>
      </Button>
      <Button onClick={onSettingsClick} type="link" size="large">
        <Column alignmentHorizontal="center" spacing="none">
          <div style={{ transform: "scale(0.80)" }}><Icon tokens={cogTokens} color={activeView === VIEWS.SETTINGS ? THEME_COLOR.TEAL_GREEN : "secondary"}/></div>
          <Theme tokens={{ textColorPrimary: THEME_COLOR.TEAL_GREEN }}>
            <Text type="b200" color={activeView === VIEWS.SETTINGS ? "primary" : "secondary"}>Settings</Text>
          </Theme>
        </Column>
      </Button>
    </Row>
  </Box>
);

export default Footer;
